export default __webpack_public_path__ + "3035c594af75e4470ef3e3351de88ab7.gif";